import { LemonaidFirebaseConfig } from './_jaettu-angular/base-firebase.service'

export enum EnvironmentType {
  LOCAL_DEV,
  DEV,
  PRODUCTION,
  BETA,
}

export interface Environment {
  enableVersionCheck: boolean
  environment: EnvironmentType
  airbrakeEnabled: boolean
  lemonatorFirebaseConfig: LemonaidFirebaseConfig
  lemonaidFirebaseConfig: LemonaidFirebaseConfig
  version: string
  host: string
  recaptchaSiteId: string
  lemonaidRecaptchaSiteId: string
  microsoftEntraTenantId: string
}
